<header class="w-full h-24 flex items-center gap-3 px-4 sm:px-8 lg:px-12 bg-gradient-to-b from-lBlack to-transparent relative z-20">
  <div class="flex shrink-0 items-center lg:min-w-[140px]">
    <img src="assets/images/unico-logo.svg" alt="unico logo" class="h-7 sm:h-9 select-none cursor-pointer" draggable="false" routerLink="/home"/>
  </div>

  <nav class="flex min-w-0 flex-1 justify-center">
    <ng-container *ngTemplateOutlet="headerMenu; context: { items: menuItems, activatedIndex: activatedIndex }">
    </ng-container>
  </nav>

  <button
    type="button"
    class="flex shrink-0 items-center justify-between gap-1 lg:min-w-60 max-w-80 px-2 lg:px-4 py-2 border border-lGray600 rounded-full bg-gradient-to-l from-transparent to-lGray400/10 cursor-pointer backdrop-blur-md transition-all duration-200 hover:bg-lWhite/5"
    (click)="toggleMenu()"
  >
    <div class="flex items-center gap-3 lg:w-full">
      <l-avatar [name]="me?.name || 'Usuário'" [imageUrl]="avatarUrl" />

      <div class="hidden flex-col items-start text-lGray50 text-sm font-medium lg:flex">
        {{ me?.name }}

        <small class="text-lSecondary text-xs">
          {{ me?.email }}
        </small>
      </div>
    </div>

    <l-icon class="text-lGray600 light:text-lSecondary text-xl transition-transform duration-200" [ngClass]="{ 'rotate-180': open }">
      keyboard_arrow_down
    </l-icon>
  </button>

  @if (open) {
    <div
      class="absolute right-4 sm:right-8 lg:right-12 top-24 min-w-60 max-w-[calc(100vw-2rem)] sm:max-w-80 z-50"
      lOutsideClick
      (outsideClick)="toggleMenu()"
    >
      <div
        class="bg-lGray400/15 light:bg-lSurface rounded-3xl p-3 text-lGray50 shadow-xl border border-lGray600 overflow-hidden backdrop-blur-sm"
      >
        <div class="flex flex-col gap-2">
          <!-- Em telas menores o botão mostra só o avatar, então nome e e-mail aparecem aqui -->
          <div class="flex flex-col border-b border-lGray600 px-2 pb-3 text-sm font-medium lg:hidden">
            <span class="break-words">{{ me?.name }}</span>
            <small class="break-all text-xs text-lSecondary">{{ me?.email }}</small>
          </div>


          @for (item of profileActions; track item.label) {

            @if (item.type === 'link') {
              <a
                [routerLink]="item.link"
                (click)="toggleMenu()"
                class="flex items-center gap-3 rounded-lg px-2 py-2 text-sm hover:bg-lWhite/10 transition"
              >
                <l-icon class="text-base">{{ item.icon }}</l-icon>
                {{ item.label }}
              </a>
            }

            @if (item.type === 'action') {
              <button
                type="button"
                role="switch"
                aria-checked="false"
                [attr.aria-checked]="theme() === themeEnum.LIGHT"
                (click)="toggleTheme()"
                class="flex items-center gap-3 rounded-lg px-2 py-2 text-sm hover:bg-lWhite/10 transition"
              >
                <l-icon class="text-base">{{ theme() === themeEnum.LIGHT ? 'dark_mode' : 'light_mode' }}</l-icon>
                {{ theme() === themeEnum.LIGHT ? 'Tema escuro' : 'Tema claro' }}
              </button>

              <hr class="my-2 border-t border-lGray600" />

              <button
                (click)="item.action?.(); toggleMenu()"
                class="flex items-center gap-3 rounded-lg px-2 py-2 text-sm hover:bg-lWhite/10 transition"
              >
                <l-icon class="text-base">{{ item.icon }}</l-icon>
                {{ item.label }}
              </button>
            }
          }

        </div>
      </div>
    </div>
  }

</header>

<ng-template #headerMenu let-items="items" let-activatedIndex="activatedIndex">
  <ol class="flex min-w-0 items-center gap-2 overflow-x-auto py-3 [scrollbar-width:none] sm:gap-4">
    @for (item of items; track $index) {
    <li class="shrink-0 transition-all duration-200">
      <a [routerLink]="item.link" class="whitespace-nowrap px-4 py-3 sm:px-6 rounded-full text-sm font-medium transition-all duration-200  border"
        [ngClass]="
            $index === activatedIndex
              ? 'bg-lPrimary text-white shadow-neon-primary  border-lPrimary'
              : 'text-lGray600 light:text-lSecondary border-lGray600 bg-gradient-to-l from-transparent to-lGray400/10 hover:bg-gradient-to-r'
          ">
        {{ item.label }}
      </a>
    </li>
    }
  </ol>
</ng-template>